<svg width="50" height="50" class="settings-tile-svg-stroke tile__svg-stroke">
    <circle cx="25" cy="25" r="24" class="settings-tile-svg-stroke tile__svg-stroke"
            stroke-width="2" stroke-opacity="0.2" fill="none"></circle>
    <path [attr.d]="circlePath"
          class="settings-tile-svg-fill tile__svg-fill"
          stroke="none"
          *ngIf="showPath">
    </path>
    <text x="24" y="26" font-size="14" text-anchor="middle" stroke="none">
        {{value}}
    </text>
    <text x="26" y="38" font-size="11" text-anchor="middle" stroke="none">%</text>
</svg>
